import type { EmployeeNodeData } from 'modules/org_chart/models/NodeData'
import type { PointNode } from 'modules/org_chart/models/PointNode'

export const findTreeNodeById = (tree: PointNode[], id: number): PointNode | void => {
  return tree.find(
    (x) => x.data.type === 'employee' && (x.data as EmployeeNodeData).employee?.attributes.id === id
  )
}
